import { render, staticRenderFns } from "./bg.vue?vue&type=template&id=1667a0b2&scoped=true"
import script from "./bg.vue?vue&type=script&lang=js"
export * from "./bg.vue?vue&type=script&lang=js"
import style0 from "./bg.vue?vue&type=style&index=0&id=1667a0b2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1667a0b2",
  null
  
)

export default component.exports